export default __webpack_public_path__ + "static/media/fish&chips-bold.eec13967.otf";